<template>

  <transition
    name="notification"
    enter-active-class="notification_enter-active"
    enter-to-class="notification_enter-to"
    leave-active-class="notification_leave-active"
    leave-to-class="notification_leave-to"
    :duration="400"
  >

    <div
      v-show="isOpen"
      class="notification notification_cookie-policy"
    >

      <button
        @click="onClickCloseButton"
        class="button button_notification-close-button"
      ></button>

      <div class="notification__content">Utilizziamo cookie propri e di terzi per finalità analitiche. È possibile configurare o rifiutare i cookie facendo clic su “Configurazione dei cookie”. Inoltre, gli utenti possono accettare tutti i cookie premendo il pulsante “Accetta tutti i cookie”. Per ulteriori informazioni, è possibile consultare la nostra
        <router-link to="/privacy" class="link link_white">
          Politica sull’utilizzo dei Cookie
        </router-link>
      </div>

      <div class="notification__buttons">
        <button @click="onClickAcceptButton" class="button button-notification-accept">
          ACCETTA TUTTI I COOKIE
        </button>

        <router-link to="/privacy#100" @click.native="onClickCloseButton" class="link link__policy">
          CONFIGURAZIONE DEI COOKIE
        </router-link>
      </div>
    </div>

  </transition>

</template>

<script>
  import Cookie from '@/js/Cookie';

  export default {
    name: 'TheNotification',

    data() {
      return {
        isOpen: false,
      };
    },

    created() {
      if (Cookie.get('privacy') === undefined) {
        this.showNotification();
      }
      if (Cookie.get('gta_disabled') === undefined) {
        window['ga-disable-UA-91170168-12'] = true;
        Cookie.set('gta_disabled', '1', {
          expires: 31536000,
        });
      }
    },

    methods: {
      hideNotification() {
        this.isOpen = false;
      },

      showNotification() {
        this.isOpen = true;
      },

      onClickCloseButton() {
        this.hideNotification();
        Cookie.set('privacy', '0', {
          expires: 0,
        });
      },

      onClickAcceptButton() {
        if (Cookie.get('privacy') === undefined ||
        Cookie.get('privacy') === '0') {
          this.hideNotification();
          window['ga-disable-UA-91170168-12'] = false;
          Cookie.set('gta_disabled', '0', {
            expires: 31536000,
          });
          Cookie.set('privacy', '1', {
            expires: 31536000,
          });
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/TheNotification.vue